/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Injectable} from '@angular/core';
import {AbmsBoardSubspecialty} from './abms-board-subspecialty.model';
import {Service} from '../../../../common/service.class';
import {Observable, ReplaySubject} from 'rxjs';
import {Response} from '@angular/http';
import {Model} from '../../../../common/model.class';
import ProjectionInformation = Model.ProjectionInformation;

@Injectable()
export class AbmsBoardSubspecialtyService {

    private _service: Service;

    private _changesSubject$ = new ReplaySubject<boolean>(1);
    changes$: Observable<boolean> = this._changesSubject$;

    protected readonly _modelType = AbmsBoardSubspecialty;
    private readonly _basePath: string = 'currentUser';

    constructor(svcm: Service.InjectedMembers) {
        this._service = new Service(svcm, 'abmsBoard');
    }

    doesCurrentUserModelEntryExist(abmsIndex: number, index: number): Observable<boolean> {
        return this._service.exists(this._modelType, this._pathFor(abmsIndex, index));
    }

    getCurrentUserModelEntry(abmsIndex: number, index: number, projection?: ProjectionInformation): Observable<AbmsBoardSubspecialty|undefined> {
        return this._service.get(this._modelType, this._pathFor(abmsIndex, index), projection);
    }

    updateCurrentUserModelEntry(abmsIndex: number, index: number, model: AbmsBoardSubspecialty): Observable<Response> {
        return this._service.update(model, this._pathFor(abmsIndex, index)).do(() => this._changesSubject$.next(true));
    }

    countCurrentUserModelEntries(abmsIndex: number): Observable<number> {
        return this._service.count(this._modelType, this._pathFor(abmsIndex));
    }

    private _pathFor(abmsIndex: number, index?: number) {
        return index !== undefined ? `${this._basePath}/${abmsIndex}/sub/${index}` : `${this._basePath}/${abmsIndex}`;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/board/abms/subspecialty/abms-board-subspecialty.service.ts